module.exports = __webpack_public_path__ + "img/nav_2_21 - 副本.743dd2ae.png";